import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ImagePreloader from "@/components/ImagePreloader";
import FloatingPhone from "@/components/FloatingPhone";
import HomePage from "@/pages/HomePage";
import PortfolioPage from "@/pages/PortfolioPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

// Service Pages
import InteriorPaintingPage from "@/pages/services/InteriorPaintingPage";
import ExteriorPaintingPage from "@/pages/services/ExteriorPaintingPage";
import CabinetPaintingPage from "@/pages/services/CabinetPaintingPage";
import DeckFenceStainingPage from "@/pages/services/DeckFenceStainingPage";
import DrywallRepairPage from "@/pages/services/DrywallRepairPage";
import ColorConsultationPage from "@/pages/services/ColorConsultationPage";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/interior-painting" element={<InteriorPaintingPage />} />
            <Route path="/services/exterior-painting" element={<ExteriorPaintingPage />} />
            <Route path="/services/cabinet-painting" element={<CabinetPaintingPage />} />
            <Route path="/services/deck-fence-staining" element={<DeckFenceStainingPage />} />
            <Route path="/services/drywall-repair" element={<DrywallRepairPage />} />
            <Route path="/services/color-consultation" element={<ColorConsultationPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingPhone />
        <ImagePreloader />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
